import { render, staticRenderFns } from "./ProfitAndCashFlowProfitAndLoss.vue?vue&type=template&id=5170d498"
import script from "./ProfitAndCashFlowProfitAndLoss.vue?vue&type=script&lang=js"
export * from "./ProfitAndCashFlowProfitAndLoss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports